import BlogGridView from "../../../commonComponents/blogGridView";

const Blog3MasonryContainer = () => {
  return <BlogGridView type="masonry" gridSize={3} />;
};

export default Blog3MasonryContainer;
